import { render } from "./the-380-Banner.vue?vue&type=template&id=f2e16cee&scoped=true"
import script from "./the-380-Banner.vue?vue&type=script&lang=js"
export * from "./the-380-Banner.vue?vue&type=script&lang=js"

import "./the-380-Banner.vue?vue&type=style&index=0&id=f2e16cee&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e16cee"]])

export default __exports__